/**
 * Runner registry.
 *
 * A domain pack names a runner in `pack.json`; the backend passes that name
 * through on session start, and this maps it to an implementation. Adding a topic
 * that reuses an existing runner needs no change here at all — which is the point
 * of the pack format.
 */

import { CompanionRunner } from "./companion";
import { createP5Runner } from "./p5";
import { createPyodideRunner } from "./pyodide";
import { createStrudelRunner } from "./strudel";
import type { Runner } from "./types";

export type RunnerId = "pyodide" | "strudel" | "p5" | "none";

export function createRunner(id: string): Runner {
  switch (id) {
    case "pyodide":
      return createPyodideRunner();
    case "strudel":
      return createStrudelRunner();
    case "p5":
      return createP5Runner();
    case "none":
      return new CompanionRunner();
    default:
      // A pack naming a runner the browser does not have should degrade to
      // companion mode, not break the session.
      console.warn(`unknown runner "${id}" — falling back to companion mode`);
      return new CompanionRunner();
  }
}

export * from "./types";
